<template>
  <div>RESULTS</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
</style>